import { createAsyncThunk } from '@reduxjs/toolkit';
import { UserDataApi, UserDataRequestCredentials } from 'api/UserDataApi';

export const createGetPayrollUserDataThunk = (api: UserDataApi) =>
  createAsyncThunk('userPayrollData/getData', async (payload: UserDataRequestCredentials) => api.getUserData(payload));
